import React from 'react';
import { IconBaseProps } from 'react-icons';
import { MdVolumeUp } from 'react-icons/md';

const Volume: React.FC<IconBaseProps> = (props) => <MdVolumeUp {...props} />;

export default Volume;
